module.exports = __webpack_public_path__ + "static/media/sbg.7bf80bb2.jpg";